/*
darkmode用到的变量和事件
*/

import Vue from '../vue.runtime.common.js';
import Env from '../env.js';

export const DarkModePlugin = {
  install() {
    Vue.mixin({
      data() {
        return {
          // 判断目前是否在dark mode下
          isDarkMode: Env.isDarkMode,
        }
      },
      computed: {
        // 最外层标记 dark mode 的 class 名
        darkModeClass() {
          return 'wg_dark_mode'
        }
      },
      methods: {
        // 传入一个dom对象，判断这个对象是否处在darkModeClass之下。
        // 有些组件在js中赋颜色值，这时候不能确定最外层的页面是否想要支持darkmode，所以需要这个方法。
        // 但更推荐的做法是，在js中为元素增减class，继续通过css的能力来切换dark。
        isDomInDarkMode(dom) {
          const els = [];
          while (dom) {
            els.unshift(dom);
            dom = dom.parentNode;
          }
          return els.some(el => {
            return el.classList && el.classList.contains(this.darkModeClass)
          })
        }
      },
      created() {
        if(Env.isCSR) return;
        const self = this;

        // 安全调用页面自己定义的 onDarkModeChange 事件
        function safeOnDarkModeChange() {
          self.onDarkModeChange && self.onDarkModeChange();
        }

        Env.onDarkModeChange(() => {
          self.isDarkMode = Env.isDarkMode;
          safeOnDarkModeChange();
        })
      }
    })
  }
}